/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React from 'react'

import { BaseIcon, IconVariantComponent } from './BaseIcon'
import { CARDS_NAMES } from './cards/constants'

type PaymentNamesType = typeof CARDS_NAMES
type PaymentNamesKeys = keyof PaymentNamesType
export type PaymentIconNames = PaymentNamesType[PaymentNamesKeys]

export type PaymentIconComponent = IconVariantComponent & {
  Amex: IconVariantComponent
  Applepay: IconVariantComponent
  CashPay: IconVariantComponent
  Cirrus: IconVariantComponent
  Dinersclub: IconVariantComponent
  Discover: IconVariantComponent
  GenericBank: IconVariantComponent
  Jcb: IconVariantComponent
  Maestro: IconVariantComponent
  Mastercard: IconVariantComponent
  Unionpay: IconVariantComponent
  Visa: IconVariantComponent
}

export const PaymentIcon: PaymentIconComponent = (props) => {
  return <BaseIcon {...props} />
}

const Amex: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.AMEX} {...otherProps} />
}
const Applepay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.APPLEPAY} {...otherProps} />
}
const CashPay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.CASHPAY} {...otherProps} />
}
const Cirrus: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.CIRRUS} {...otherProps} />
}
const Dinersclub: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.DINERSCLUB} {...otherProps} />
}
const Discover: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.DISCOVER} {...otherProps} />
}
const GenericBank: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.GENERICBANK} {...otherProps} />
}
const Jcb: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.JCB} {...otherProps} />
}
const Maestro: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.MAESTRO} {...otherProps} />
}
const Mastercard: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.MASTERCARD} {...otherProps} />
}
const Unionpay: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.UNIONPAY} {...otherProps} />
}
const Visa: IconVariantComponent = (props) => {
  const { name, ...otherProps } = props
  return <PaymentIcon name={CARDS_NAMES.VISA} {...otherProps} />
}

PaymentIcon.Amex = Amex
PaymentIcon.Applepay = Applepay
PaymentIcon.CashPay = CashPay
PaymentIcon.Cirrus = Cirrus
PaymentIcon.Dinersclub = Dinersclub
PaymentIcon.Discover = Discover
PaymentIcon.GenericBank = GenericBank
PaymentIcon.Jcb = Jcb
PaymentIcon.Maestro = Maestro
PaymentIcon.Mastercard = Mastercard
PaymentIcon.Unionpay = Unionpay
PaymentIcon.Visa = Visa
